<template>
  <span>
    <b-button variant="info" size="sm" @click="$router.push({ name: 'dashboard' })">
      <i class="fa fa-table"></i>
      Lista de Pedidos
    </b-button>
    &nbsp;
    <b-button size="sm" :to="{ name: 'Importacao' }">
      <i aria-hidden="true" class="fa fa-upload"></i>
      Importação
    </b-button>
    &nbsp;
    <b-button size="sm" :to="{ name: 'Exportacoes' }">
      <i aria-hidden="true" class="fa fa-download"></i>
      Exportações
    </b-button>
    &nbsp;
    <b-button size="sm" :to="{ name: 'Etiquetas' }">
      <i aria-hidden="true" class="fa fa-download"></i>
      Etiquetas
    </b-button>
  </span>
</template>

<script>
export default {
  name: "ScreensMenu",
  props: ["checkFaturador"],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/ScreensMenu.vue